'use client';

import { raptiveAdManager, type SlotRenderEvent, type RaptiveAdPlacementType } from '@benzinga/ads-utils';
import { useAdImpression, type useAdImpressionResult } from './useAdImpression';

interface UseRaptiveAdImpressionProps {
  adContainerId: string | null;
  placementType: RaptiveAdPlacementType;
}

export function useRaptiveAdImpression({
  adContainerId,
  placementType,
}: UseRaptiveAdImpressionProps): useAdImpressionResult<SlotRenderEvent> {
  return useAdImpression<SlotRenderEvent>({
    containerId: adContainerId,
    manager: raptiveAdManager,
    partnerId: 'raptive',
    unitType: `raptive-${placementType}`,
  });
}
